import { useEffect, useMemo } from "react";
import { css } from "@emotion/react";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { useIsPC } from "../../hooks";
import { fadeInVariants } from "../../constants/animations";

const Intro = () => {
  const isPC = useIsPC();

  // Introduction
  const [refIntoroduction, inViewIntroduction] = useInView();
  const controlsIntroduction = useAnimation();
  useEffect(() => {
    if (inViewIntroduction) {
      controlsIntroduction.start("visible");
    }
  }, [controlsIntroduction, inViewIntroduction]);

  // Top
  const [refTop, inViewTop] = useInView();
  const controlsTop = useAnimation();
  useEffect(() => {
    if (inViewTop) {
      controlsTop.start("visible");
    }
  }, [controlsTop, inViewTop]);

  // Top-Bottom
  const [refTopBottom, inViewTopBottom] = useInView();
  const controlsTopBottom = useAnimation();
  useEffect(() => {
    if (inViewTopBottom) {
      controlsTopBottom.start("visible");
    }
  }, [controlsTopBottom, inViewTopBottom]);

  // Top-Center-Title
  const [refTopCenterTitle, inViewTopCenterTitle] = useInView();
  const controlsTopCenterTitle = useAnimation();
  useEffect(() => {
    if (inViewTopCenterTitle) {
      controlsTopCenterTitle.start("visible");
    }
  }, [controlsTopCenterTitle, inViewTopCenterTitle]);

  // Top-Bottom-Sub
  const [refTopBottomSub, inViewTopBottomSub] = useInView();
  const controlsTopBottomSub = useAnimation();
  useEffect(() => {
    if (inViewTopBottomSub) {
      controlsTopBottomSub.start("visible");
    }
  }, [controlsTopBottomSub, inViewTopBottomSub]);

  // Roke
  const [refRoke, inViewRoke] = useInView();
  const controlsRoke = useAnimation();
  useEffect(() => {
    if (inViewRoke) {
      controlsRoke.start("visible");
    }
  }, [controlsRoke, inViewRoke]);

  // Genre
  const [refGenre, inViewGenre] = useInView();
  const controlsGenre = useAnimation();
  useEffect(() => {
    if (inViewGenre) {
      controlsGenre.start("visible");
    }
  }, [controlsGenre, inViewGenre]);

  // Center
  const [refCenter, inViewCenter] = useInView();
  const controlsCenter = useAnimation();
  useEffect(() => {
    if (inViewCenter) {
      controlsCenter.start("visible");
    }
  }, [controlsCenter, inViewCenter]);

  // Bottom
  const [refBottom, inViewBottom] = useInView();
  const controlsBottom = useAnimation();
  useEffect(() => {
    if (inViewBottom) {
      controlsBottom.start("visible");
    }
  }, [controlsBottom, inViewBottom]);

  const topImgSrc = useMemo(() => {
    return (
      process.env.REACT_APP_BASE_PATH +
      "/img/intro-top-txt" +
      (isPC ? "" : "-sp") +
      ".png"
    );
  }, [isPC]);

  return (
    <div css={mainStyle} id="introduction">
      <div css={contentsWrapperStyle}>
        <div css={topContentsContainerStyle}>
          <div css={topContentsWrapperStyle}>
            <motion.div
              css={titleStyle(40, 40)}
              ref={refIntoroduction}
              initial="hidden"
              animate={controlsIntroduction}
              variants={fadeInVariants}
            >
              INTRODUCTION
            </motion.div>
            <motion.div
              css={topTxtWrapperStlye}
              ref={refTop}
              initial="hidden"
              animate={controlsTop}
              variants={fadeInVariants}
            >
              <img
                src={process.env.REACT_APP_BASE_PATH + "/img/intro-top-txt.png"}
                css={topTxtStyle()}
              />
            </motion.div>
            <motion.div
              css={topBottomTxtWrapperStlye}
              ref={refTopBottom}
              initial="hidden"
              animate={controlsTopBottom}
              variants={fadeInVariants}
            >
              <img
                src={
                  process.env.REACT_APP_BASE_PATH +
                  "/img/intro-top-bottom-txt.png"
                }
                css={topTxtStyle(75)}
              />
            </motion.div>
            <motion.div
              css={topCenterTitleWrapperStlye}
              ref={refTopCenterTitle}
              initial="hidden"
              animate={controlsTopCenterTitle}
              variants={fadeInVariants}
            >
              <img
                src={
                  process.env.REACT_APP_BASE_PATH +
                  "/img/intro-top-center-title-txt.png"
                }
                css={topCenterTitleTxtStyle}
              />
            </motion.div>
            <motion.div
              css={topBottomSubTxtWrapperStlye}
              ref={refTopBottomSub}
              initial="hidden"
              animate={controlsTopBottomSub}
              variants={fadeInVariants}
            >
              <img
                src={
                  process.env.REACT_APP_BASE_PATH +
                  "/img/intro-top-bottom-sub-txt.png"
                }
                css={topTxtStyle(75)}
              />
            </motion.div>
          </div>
        </div>
        <div css={lowerMiddleContainerStyle}>
          <div css={rokeContainerStyle}>
            <motion.div
              css={rokeWrapperStyle}
              ref={refRoke}
              initial="hidden"
              animate={controlsRoke}
              variants={fadeInVariants}
            >
              <img
                src={
                  process.env.REACT_APP_BASE_PATH + "/img/intro-roke-txt.png"
                }
                css={rokeTxtStyle}
              />
            </motion.div>
          </div>
          <div css={centerTxtWrapperStlye}>
            <motion.img
              src={
                process.env.REACT_APP_BASE_PATH + "/img/intro-center-txt.png"
              }
              css={centerTxtStyle}
              ref={refCenter}
              initial="hidden"
              animate={controlsCenter}
              variants={fadeInVariants}
            />
          </div>
        </div>
        <div css={bottomContentsContainerStyle}>
          <div css={bottomContentsWrapperStyle}>
            <motion.div
              ref={refBottom}
              initial="hidden"
              animate={controlsBottom}
              variants={fadeInVariants}
            >
              <div css={titleStyle(40, 40)} id="story">
                STORY
              </div>
              <div css={bottomTxtWrapperStyle}>
                <img
                  src={
                    process.env.REACT_APP_BASE_PATH +
                    "/img/intro-bottom-txt.png"
                  }
                  css={bottomTxtStyle}
                />
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
`;

const contentsWrapperStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const topContentsContainerStyle = css`
  position: relative;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/bg-intro.jpg"});
  background-size: cover;
  width: 100%;
`;

const topContentsWrapperStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(40, 72, 90, 0.45);
  padding-top: 40px;

  @media (max-width: ${spSize}px) {
    padding-top: 30px;
  }
`;

const bottomContentsContainerStyle = css`
  position: relative;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/bg-bottom-intro.jpg"});
  background-position: center;
  background-size: cover;
  width: 100%;
`;

const bottomContentsWrapperStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(40, 72, 90, 0.47);
  padding-bottom: 60px;

  @media (max-width: ${spSize}px) {
    padding-bottom: 40px;
  }
`;

const titleStyle = (paddingTop?: number, paddingTopSp?: number) => css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;
  padding-top: ${paddingTop ? paddingTop : 0}px;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
    font-weight: 400;
    padding-top: ${paddingTopSp ? paddingTopSp : 0}px;
  }
`;

const topTxtWrapperStlye = css`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0 60px;

  @media (max-width: ${spSize}px) {
    padding: 30px 0 30px;
  }
`;

const topBottomTxtWrapperStlye = css`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 60px;

  @media (max-width: ${spSize}px) {
    padding-bottom: 40px;
  }
`;

const topCenterTitleWrapperStlye = css`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0 60px;

  @media (max-width: ${spSize}px) {
    padding: 0px 0 10px;
  }
`;

const topBottomSubTxtWrapperStlye = css`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0 60px;

  @media (max-width: ${spSize}px) {
    padding: 20px 0 40px;
  }
`;

const topTxtStyle = (spWidth?: number) => css`
  width: 100%;
  max-width: 600px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: ${spWidth ?? 80}%;
  }
`;

const topCenterTitleTxtStyle = css`
  width: 100%;
  max-width: 550px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 70%;
  }
`;

const centerTxtWrapperStlye = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  background-color: rgba(5, 39, 51, 0.9);

  @media (max-width: ${spSize}px) {
    padding: 40px 0;
  }
`;

const centerTxtStyle = css`
  width: 100%;
  max-width: 550px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 75%;
  }
`;

const bottomTxtWrapperStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;

  @media (max-width: ${spSize}px) {
    padding: 20px 0 0;
  }
`;

const bottomTxtStyle = css`
  width: 100%;
  max-width: 600px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 80%;
  }
`;

const lowerMiddleContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/bg-all-roke.jpg"});
  background-position: center;
  background-size: cover;
`;

const rokeContainerStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
  background-color: rgba(41, 73, 91, 0.32);

  @media (max-width: ${spSize}px) {
    padding: 40px 0;
  }
`;

const rokeWrapperStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const rokeTxtStyle = css`
  width: 100%;
  max-width: 600px;
  height: auto;

  @media (max-width: ${spSize}px) {
    width: 75%;
  }
`;

export default Intro;
